import React, {useRef, useEffect } from 'react'
import styled from 'styled-components'

// This component renders the hours aligned with the grid lines. We don't render this when max-width is less than 400px.

const TheBack = styled.div`
  position: absolute;
  z-index: -300;
  left: -100px;
  display: flex;
  flex-direction: column;
  * {
    height: 90px;
  }
  @media screen and (max-width: 400px) {
    display: none
  }
`
const TheBackHalves = styled.div`
  position: absolute;
  z-index: -300;
  left: -48px;
  display: flex;
  flex-direction: column;
  top: 45px;
  * {
    height: 90px;
  }
  @media screen and (max-width: 400px) {
    display: none
  }
`
const Half = styled.div`
  position: relative;
  color: #939393;
  &::before {
    content: '_______';
    position: absolute;
    top: -18px;
    right: -10px;
    color: #d4dee0;
  }
`
const Full = styled.div`
  position: relative;
  font-weight: 600;
  &::before {
    content: '________________';
    position: absolute;
    top: -18px;
    color: #b7bec0
  }
`
const FullAM = styled.div`
  position: relative;
  font-weight: 600;
  &::before {
    content: '________________';
    position: absolute;
    top: -18px; 
    color: #b7bec0
  }
  &::after {
    content: 'AM';
    position: absolute;
    top: 0; 
    left: -4.2rem;
    color: #EE247C;
    font-size: 2rem;
  }
`
const FullPM = styled.div`
  position: relative;
  font-weight: 600;
  &::before {
    content: '________________';
    position: absolute;
    top: -18px; 
    color: #b7bec0
  }
  &::after {
    content: 'PM';
    position: absolute;
    top: 0; 
    left: -4.2rem;
    color: #3FA9F5;
    font-size: 2rem;
  }
`

export default function UIHours (props) {
  // We use a REF to memorize the offset from the top of the div with text "8:00", and we scroll to it onMount
  const scrollToEigth = useRef(null)

  useEffect(() => {
    window.scrollTo(0, scrollToEigth.current.offsetTop)
  }, [])

  return (
    <>
      <TheBack>
          <FullAM>12:00</FullAM>
          <Full>1:00</Full>
          <Full>2:00</Full>
          <Full>3:00</Full>
          <Full>4:00</Full>
          <Full>5:00</Full>
          <Full>6:00</Full>
          <Full>7:00</Full>
          <Full ref={scrollToEigth}>8:00</Full>
          <Full>9:00</Full>
          <Full>10:00</Full>
          <Full>11:00</Full>
          <FullPM>12:00</FullPM>
          <Full>1:00</Full>
          <Full>2:00</Full>
          <Full>3:00</Full>
          <Full>4:00</Full>
          <Full>5:00</Full>
          <Full>6:00</Full>
          <Full>7:00</Full>
          <Full>8:00</Full>
          <Full>9:00</Full>
          <Full>10:00</Full>
          <Full>11:00</Full>
          <Full>00:00</Full>
      </TheBack>
      <TheBackHalves>
          <Half>12:30</Half>
          <Half>1:30</Half>
          <Half>2:30</Half>
          <Half>3:30</Half>
          <Half>4:30</Half>
          <Half>5:30</Half>
          <Half>6:30</Half>
          <Half>7:30</Half>
          <Half>8:30</Half>
          <Half>9:30</Half>
          <Half>10:30</Half>
          <Half>11:30</Half>
          <Half>12:30</Half>
          <Half>1:30</Half>
          <Half>2:30</Half>
          <Half>3:30</Half>
          <Half>4:30</Half>
          <Half>5:30</Half>
          <Half>6:30</Half>
          <Half>7:30</Half>
          <Half>8:30</Half>
          <Half>9:30</Half>
          <Half>10:30</Half>
          <Half>11:30</Half>
      </TheBackHalves>
    </>
  )
}